/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import styles from './styles.module.scss';
import { Divider, View } from '@az/starc-ui';
import type { ReviewType } from '../../interface/types';
import { Review } from '../Review/Review';
import { Fragment } from 'react';
import { LoadingReview } from '../Review/LoadingReview/LoadingReview';

type ReviewsListProps = {
  reviews: ReviewType[];
  isLoading: boolean;
};

export const ReviewsList = ({ reviews, isLoading }: ReviewsListProps) => {
  return (
    <View as="ul" className={styles.reviewsList}>
      {isLoading ? (
        <>
          <LoadingReview />
          <Divider />
          <LoadingReview />
          <Divider />
          <LoadingReview />
        </>
      ) : (
        reviews?.map((review, index) => {
          const isLastReview = index === reviews.length - 1;

          return (
            <Fragment key={review.reviewId}>
              <View as="li">
                <Review review={review} />
              </View>
              {!isLastReview ? <Divider /> : null}
            </Fragment>
          );
        })
      )}
    </View>
  );
};
